<nav class="profile-tabs" [attr.aria-label]="navLabel">
  <div class="profile-tabs__inner">
    @for (tab of tabs; track tab.path) {
      <a
        class="profile-tabs__tab"
        [routerLink]="tab.path"
        routerLinkActive="profile-tabs__tab--active"
        ariaCurrentWhenActive="page"
        [attr.aria-label]="tab.label"
      >
        <app-icon [icon]="tab.icon" [size]="18" />
        <span class="profile-tabs__label">{{ tab.label }}</span>
      </a>
    }
  </div>
</nav>
